


const initialState = {
//   catPaperCreated: null,
};

export default function catPaperReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    // case GENERATE_PAPER_SUCCESS:
    //   return {
    //     ...state,
    //     catPaperCreated: payload,
    //   };
    // case GENERATE_PAPER_FAILURE:
    //   return {
    //     ...state,
    //     message: "",
    //   };

    //     case HISTORY_ASSIGNMENT_SUCCESS:
    //   return {
    //     ...state,
    //     assignment_history: payload,
    //   };
    // case HISTORY_ASSIGNMENT_FAILURE:
    //   return {
    //     ...state,
    //     message: "",
    //   };

    //     case CREATE_ALL_ASSIGNMENT_SUCCESS:
    //   return {
    //     ...state,
    //     allAssignment: payload,
    //   };
    // case CREATE_ALL_ASSIGNMENT_FAILURE:
    //   return {
    //     ...state,
    //     message: "",
    //   };

    default:
      return state;
  }
}
